import Shepherd from "shepherd.js";

// Functions:
// Popper.js or Shepherd.js must alter these variable as only works on first call 
function tetherUnderneath() {
  return { 
    placement: "bottom",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 16]
        }
      }
    ]
  };
};

function tetherAbove() {
  return { 
    placement: "top",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 16]
        }
      }
    ]
  };
};

function tetherOnLeft() {
  return { 
    placement: "left",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0,16]
        }
      }
    ]
  };
};

function popperOptions() {
  return {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0,16]
        }
      }
    ]
  };
}

function conditionsMet(elements) {
  const isPresent = selector => document.querySelector(selector) !== null;
  const isNullOrPresent = s => s == null || isPresent(s);
  const isNullOrNotPresent = s => s == null || !isPresent(s);

  return isPresent(elements.show) &&
    isNullOrPresent(elements.alsoShow) &&
    isNullOrNotPresent(elements.hide);
}
function waitForElements(elements) {
  const waitTillNextAnimationFrame = () => new Promise(requestAnimationFrame);

  if (conditionsMet(elements)) {
    return Promise.resolve(true);
  } else {
    return waitTillNextAnimationFrame().then(() => waitForElements(elements));
  }
}

function highlightElStep(tour, text, elements, attachOn = "bottom") {
  return {
    text: text,
    attachTo: { element: elements.show, on: attachOn },
    highlightClass: "tour-pointer-events-none", // no click allowed when showing
    modalOverlayOpeningPadding: 2,
    buttons: [
      {
        text: "Close",
        action: tour.cancel,
        secondary: true
      },
      { text: "Next", action: tour.next }
    ],
    popperOptions: popperOptions(),
    beforeShowPromise: () => waitForElements(elements)
  };
}

function clickElStep(text, element, attachOn = "bottom" ) {
  return {
    text: text,
    attachTo: { element: element, on: attachOn },
    advanceOn: { selector: element, event: "click" },
    highlightClass: "pulse-shadow",
    modalOverlayOpeningPadding: 2,
    popperOptions: popperOptions(),
    beforeShowPromise: () => waitForElements({"show": element})
  };
}

function makeModalTour(opts = {}) {
  const defaults = {
    confirmCancel: true,
    confirmCancelMessage: "It won't take long to step through - are you sure?",
    useModalOverlay: true,
    defaultStepOptions: {
      arrow: true
    }
  };
  return new Shepherd.Tour({ ...defaults, ...opts });
}

export default {
  highlightElStep,
  clickElStep,
  makeModalTour
};
